<kt-portlet>
  <!-- PORTLET LOADING | Binded to TABLE Datasource -->
  <!-- See prop => '~/core/_crud/models/data-sources/_base.datasource.ts' (loading$) -->
  <kt-portlet-header
    title="{{ 'PATIENT.PATIENT_WEIGHT.WEIGHT_LIST' | translate }}"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource.loading$"
  >
    <ng-container ktPortletTools>
      <div class="col-md-2 text-right kt-margin-bottom-10-mobile">
        <button
          type="button"
          (click)="addWeightButtonOnClick()"
          mat-raised-button
          color="primary"
          matTooltip="Create new weight"
          [disabled]="weightForAdd._isEditMode || isSwitchedToEditMode"
        >
          {{ 'PATIENT.PATIENT_WEIGHT.TABLE.NEW_WEIGHT' | translate }}
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <!-- end::Header -->

  <!-- start::Body (attribute: ktPortletBody) -->
  <kt-portlet-body>
    <!-- MATERIAL TABLE | Binded to datasources -->
    <!-- See off.documentations 'https://material.angular.io/components/table/overview' -->
    <div class="mat-table-wrapper">
      <form [formGroup]="formGroup">
        <mat-table
          class="lmat-elevation-z8 mat-table-wrapper-dialog"
          #table
          [dataSource]="dataSource"
          matSort
          #sort1="matSort"
          matSortActive="id"
          matSortDirection="asc"
          matSortDisableClear
        >
          <ng-container matColumnDef="add-weight">
            <mat-header-cell *matHeaderCellDef class="mat-column mat-column-patient-measurement">
              <mat-form-field *ngIf="weightForAdd._isEditMode" class="mat-form-field-fluid">
                <input matInput placeholder="Enter Weight" formControlName="newWeight" />
                <mat-hint align="start"
                  >{{ 'PATIENT.PATIENT_WEIGHT.TABLE.PLEASE_ENTER' | translate }}
                  <strong>{{ getWeightTitle() | translate }}</strong>
                </mat-hint>
              </mat-form-field>
            </mat-header-cell>
          </ng-container>

          <ng-container matColumnDef="add-startDate">
            <mat-header-cell *matHeaderCellDef class="mat-column mat-column-patient-measurement">
              <mat-form-field *ngIf="weightForAdd._isEditMode" class="mat-form-field-fluid">
                <input
                  matInput
                  [matDatepicker]="addPicker"
                  placeholder="Choose a Start Date"
                  formControlName="newStartDate"
                />
                <mat-datepicker-toggle matSuffix [for]="addPicker"></mat-datepicker-toggle>
                <mat-datepicker #addPicker></mat-datepicker>
                <mat-hint align="start"
                  >{{ 'PATIENT.PATIENT_WEIGHT.TABLE.PLEASE_ENTER' | translate }}
                  <strong>{{ 'PATIENT.PATIENT_WEIGHT.TABLE.START_DATE' | translate }}</strong>
                </mat-hint>
              </mat-form-field>
            </mat-header-cell>
          </ng-container>

          <ng-container matColumnDef="add-actions">
            <mat-header-cell
              *matHeaderCellDef
              class="mat-column mat-column-patient-measurement mat-column-actions"
            >
              <span class="mat-column-actions-wrapper" *ngIf="weightForAdd._isEditMode">
                <button
                  *ngIf="!loadingAfterSubmit"
                  mat-icon-button
                  color="{{ checkAddForm() ? 'primary' : 'accent' }}"
                  type="button"
                  (click)="saveNewWeight()"
                  matTooltip="Save new Weight"
                >
                  <mat-icon>done</mat-icon>
                </button>
                <mat-spinner *ngIf="loadingAfterSubmit" [diameter]="20"></mat-spinner>
                &nbsp;
                <button
                  type="button"
                  mat-icon-button
                  color="wan"
                  (click)="cancelAddButtonOnClick()"
                  matTooltip="Cancel changes"
                >
                  <mat-icon>clear</mat-icon>
                </button>
              </span>
            </mat-header-cell>
          </ng-container>

          <ng-container matColumnDef="weight">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{
              getWeightTitle() | translate
            }}</mat-header-cell>
            <mat-cell *matCellDef="let weight">{{ convertWeight(weight.weight) }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="start_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{
              'PATIENT.PATIENT_WEIGHT.TABLE.START_DATE' | translate
            }}</mat-header-cell>
            <mat-cell *matCellDef="let weight">
              {{ weight.start_date | date : 'MM-dd-yy' }}
            </mat-cell>
          </ng-container>

          <!-- <ng-container matColumnDef="actions" *ngIf="">
                        <mat-header-cell *matHeaderCellDef class="mat-column mat-column-actions">
                            Actions
                        </mat-header-cell>
                        <mat-cell *matCellDef="let weight" class="mat-column mat-column-actions">
                            <button *ngIf="!weight._isEditMode" [disabled]="isSwitchedToEditMode" type="button" mat-icon-button color="primary" (click)="editWeightButtonOnClick(weight)"
                                matTooltip="Edit weight">
                                <mat-icon>create</mat-icon>
                            </button>
                            <button *ngIf="weight._isEditMode && !loadingAfterSubmit" mat-icon-button color="{{checkEditForm() ? 'primary' : 'accent'}}"
                                type="button" (click)="saveUpdatedWeight(weight)" matTooltip="Save changes">
                                <mat-icon>done</mat-icon>
                            </button>
                            <mat-spinner *ngIf="weight._isEditMode && loadingAfterSubmit" [diameter]="20"></mat-spinner>
                            &nbsp;
                            <button *ngIf="!weight._isEditMode" [disabled]="isSwitchedToEditMode" mat-icon-button color="warn" type="button" (click)="deleteWeight(weight)"
                                matTooltip="Delete weight">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button *ngIf="weight._isEditMode" type="button" mat-icon-button color="warn" (click)="cancelEditButtonOnClick(weight)" matTooltip="Cancel changes">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container> -->

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          <mat-header-row
            *matHeaderRowDef="['add-weight', 'add-startDate', 'add-actions']"
            class="mat-row-editing mat-row-add"
            [ngClass]="{ 'mat-row-inactive': !weightForAdd._isEditMode }"
          >
          </mat-header-row>
        </mat-table>
      </form>
      <div class="mat-table__message" *ngIf="!dataSource.hasItems">
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
      <!-- Message for empty data  -->
      <div class="mat-table__message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLAESE_WAIT' | translate }}
      </div>
    </div>

    <!-- start: BOTTOM -->
    <div class="mat-table__bottom">
      <!-- MATERIAL SPINNER | Url: 'https://material.angular.io/components/progress-spinner/overview' -->
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <!-- MATERIAL PAGINATOR | Binded to dasources -->
      <!-- See off.documentations 'https://material.angular.io/components/paginator/overview' -->
      <mat-paginator
        [pageSize]="patientWeightsResult.length"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
    <!-- end: BOTTOM -->
  </kt-portlet-body>
  <!-- end::Body -->
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button
          type="button"
          mat-raised-button
          cdkFocusInitial
          (click)="closeDialog()"
          matTooltip="Close Dialog"
        >
          {{ 'PATIENT.PATIENT_WEIGHT.CLOSE_DIALOG' | translate }}
        </button>
      </div>
    </div>
  </div>
</kt-portlet>
